import { render, staticRenderFns } from "./OverviewBOM.vue?vue&type=template&id=02189dcf&scoped=true&"
import script from "./OverviewBOM.vue?vue&type=script&lang=js&"
export * from "./OverviewBOM.vue?vue&type=script&lang=js&"
import style0 from "./OverviewBOM.vue?vue&type=style&index=0&id=02189dcf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02189dcf",
  null
  
)

export default component.exports